import styled, { css } from 'styled-components';

export const StickyContainerStyled = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 300;
  padding: 0 40px;
`;

export type BugsColumnVisibility =
  | 'hidden'
  | 'visible-empty'
  | 'visible-content';

export const ContainerStyled = styled(StickyContainerStyled)<{
  bugsColumnVisibility: BugsColumnVisibility;
}>`
  box-sizing: border-box;
  width: 100%;
  height: 80px;
  background: var(--ds-surface, var(--ds-fb-surface));
  box-shadow: var(--ds-shadow-overflow, var(--ds-fb-shadow-overflow));

  display: grid;
  align-items: center;

  ${({ bugsColumnVisibility }) => {
    switch (bugsColumnVisibility) {
      case 'hidden': {
        return css`
          grid-template-columns:
            minmax(264px, 1fr) minmax(164px, 300px) minmax(142px, 350px)
            212px;
        `;
      }

      case 'visible-empty': {
        return css`
          grid-template-columns:
            minmax(264px, 1fr) minmax(164px, 300px) minmax(142px, 350px)
            minmax(110px, 244px) 212px;
        `;
      }

      case 'visible-content': {
        return css`
          grid-template-columns:
            minmax(264px, 1fr) minmax(164px, 300px) minmax(142px, 350px)
            450px 212px;
        `;
      }

      default: {
        throw new Error(
          `Invalid bugsColumn prop value. Received: "${bugsColumnVisibility}".`
        );
      }
    }
  }}
`;

const contentHelper = css`
  box-sizing: border-box;
  padding-left: 8px;
  padding-right: 50px;
`;

const LabeledSlotStyled = styled.div<{ label?: string }>`
  width: 100%;
  position: relative;

  ::before {
    ${({ label = '' }) => {
      return css`
        content: '${label}';
      `;
    }}

    color: var(--ds-icon-subtle, var(--ds-fb-icon-subtle));

    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(calc(-100% - 8px));

    height: 100%;
    display: flex;
    align-items: center;
  }
`;

export const ItemsSlotStyled = styled.div`
  color: var(--ds-text, var(--ds-fb-text));
  font-weight: 600;
  font-size: 16px;
`;

export const StatusSelectSlotStyled = styled(LabeledSlotStyled)`
  ${contentHelper}
`;

export const AssigneeDropdownSlotStyled = styled(LabeledSlotStyled)`
  ${contentHelper}
`;

export const BugsSlotStyled = styled.div`
  /* Empty */
`;

export const UncheckButtonSlotStyled = styled.div`
  justify-self: end;
`;
